/*! License details at fancyapps.com/license */
const t=function(t=0,n=0,a=0){return Math.max(Math.min(n,a),t)};export{t as clamp};
